import { ReactElement } from "react";

interface CUSTOM_BUTTON_PROP_TYPE {
  buttonText: string;
  customClassName: string;
  handleButtonClick: () => void;
  disabled?: boolean;
  icon?: ReactElement;
}

const CustomButton = ({
  buttonText,
  customClassName,
  handleButtonClick,
  disabled,
  icon,
}: CUSTOM_BUTTON_PROP_TYPE) => {
  return (
    <button
      className={`btn ${customClassName}`}
      type="button"
      onClick={handleButtonClick}
      disabled={disabled}
    >
      {icon}
      {buttonText}
    </button>
  );
};

export default CustomButton;
